Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight,
    spacing = _STYLES$useStyles.spacing,
    boxShadows = _STYLES$useStyles.boxShadows,
    colors = _STYLES$useStyles.colors,
    focused = _STYLES$useStyles.focused;
  var container = {
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1,
    elevation: 1
  };
  var button = Object.assign({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.xs,
    backgroundColor: colors.buttonBackground,
    borderRadius: (0, _styles.getREM)(2.1875 / 2),
    paddingTop: (0, _styles.getREM)(0.4375),
    paddingRight: (0, _styles.getREM)(1),
    paddingBottom: (0, _styles.getREM)(0.4375),
    paddingLeft: (0, _styles.getREM)(1)
  }, _reactNative.Platform.select({
    web: {
      border: 0,
      cursor: 'pointer'
    }
  }), boxShadows.button.all);
  var button_focused = Object.assign({}, focused);
  var button_pressed = {
    opacity: 0.6
  };
  var buttonText = Object.assign({}, fontSemiBold, {
    alignItems: 'center',
    fontSize: fontSize.s,
    lineHeight: lineHeight.s,
    color: COLORS.aubergine,
    textDecorationLine: 'none'
  });
  var triangle = {
    position: 'absolute',
    top: 15,
    right: 15
  };
  var menu = Object.assign({
    position: 'absolute',
    top: 12,
    left: '50%',
    width: (0, _styles.getREM)(15),
    backgroundColor: COLORS.paper,
    borderRadius: (0, _styles.getREM)(1),
    padding: (0, _styles.getREM)(0.25),
    transform: [{
      translateX: (0, _styles.getREM)(-7.5)
    }]
  }, boxShadows.card.all);
  var firstMenuItem = {
    borderTopLeftRadius: (0, _styles.getREM)(1),
    borderTopRightRadius: (0, _styles.getREM)(1)
  };
  var lastMenuItem = {
    borderBottomLeftRadius: (0, _styles.getREM)(1),
    borderBottomRightRadius: (0, _styles.getREM)(1)
  };
  var triangleWhite = {
    width: 30,
    height: 30,
    position: 'absolute',
    top: -12,
    right: '45%',
    transform: [{
      rotate: '180deg'
    }]
  };
  var menuTriangle = Object.assign({
    backgroundColor: COLORS.paper,
    position: 'absolute',
    zIndex: 0,
    width: (0, _styles.getREM)(1.5),
    height: (0, _styles.getREM)(1.5),
    top: (0, _styles.getREM)(-0.75),
    left: '50%',
    marginLeft: (0, _styles.getREM)(-0.75),
    transform: [{
      rotate: '-45deg'
    }],
    borderRadius: (0, _styles.getREM)(0.25)
  }, boxShadows.card.all);
  var menuTriangleCover = {
    backgroundColor: COLORS.paper,
    position: 'absolute',
    zIndex: 0,
    width: (0, _styles.getREM)(3.2),
    height: (0, _styles.getREM)(1.6),
    top: 0,
    left: '50%',
    marginLeft: (0, _styles.getREM)(-1.6)
  };
  var menuDivider = {
    borderTopWidth: (0, _styles.getREM)(1 / 16),
    borderColor: COLORS.silver,
    marginVertical: (0, _styles.getREM)(0.25)
  };
  var menuButton = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.xs,
    padding: spacing.xs
  };
  var menuButtonText = Object.assign({}, fontSemiBold, {
    fontSize: fontSize.s,
    lineHeight: lineHeight.s,
    textAlign: 'left',
    color: COLORS.aubergine
  });
  var menuButtonHover = {
    backgroundColor: COLORS.snuff
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    button: button,
    button_focused: button_focused,
    button_pressed: button_pressed,
    buttonText: buttonText,
    menu: menu,
    firstMenuItem: firstMenuItem,
    lastMenuItem: lastMenuItem,
    triangleWhite: triangleWhite,
    menuTriangle: menuTriangle,
    menuTriangleCover: menuTriangleCover,
    triangle: triangle,
    menuDivider: menuDivider,
    menuButton: menuButton,
    menuButtonText: menuButtonText,
    menuButtonHover: menuButtonHover
  });
  return {
    styles: styles
  };
};